import React from 'react';
import toast from 'react-hot-toast';
import useApi from '../useApi';
import { IRTMPlanNewRes } from './index.type';


const useAllRTMPlan = ({ pageNumber, perpageData,frequency,status,billingCycle, search = "",sort,order }: { pageNumber: number; perpageData: number; frequency:string;status:string;billingCycle:string;search?: string,sort:string,order?: 'asc' | 'desc'  }) => {
  const [RTMPlanData, setRTMPlanData] = React.useState<IRTMPlanNewRes>();

  const { loading: RTMPlanDataLoading, makeApiCall } = useApi({
    url: `/rtm/plan?page=${pageNumber}&limit=${perpageData}&${search ? `&search=${search}` : ""}&frequency=${frequency}&status=${status}&billingCycle=${billingCycle}&sort=${sort || ''}&order=${order || ''}`,
 
    method: 'GET',
  });
  
  const getRTMPlanData = async () => {
    const { response, error } = await makeApiCall<undefined, IRTMPlanNewRes>();
    if (response?.status === 'success') {
      setRTMPlanData(response);
    }
    
    if (response?.status === 'fail') {
      setRTMPlanData(undefined);
    }
    
    if (error) toast.error('Something went wrong while fetching RTM data. Please try again later');
  };

  return {
    RTMPlanData,
    getRTMPlanData,
    RTMPlanDataLoading,
  };
};

export default useAllRTMPlan;
